'use client'

import { type ElementType } from 'react'
import type { LinkProps } from 'next/link'
import * as AriakitMenu from '@ariakit/react/menu'
import Button from '@shared/components/Button/Button'
import * as menuStyles from './Menu.css'

interface MenuItemProps extends AriakitMenu.MenuItemProps {
  icon?: ElementType
  iconColor?: string
  /**
   * Render the item as a `next/link` anchor. Prefer this over passing a
   * raw `<Link>` via `render` — Button's link integration carries the
   * shared menu item styling (flex/gap/icon alignment), whereas a bare
   * `<Link>` falls back to default anchor block layout and stacks the
   * icon above the text.
   */
  href?: LinkProps['href']
  [key: string]: any
}
export function MenuItem({
  children,
  icon: Icon,
  iconColor,
  href,
  ...props
}: MenuItemProps) {
  return (
    <AriakitMenu.MenuItem
      render={
        props.render ?? (
          <Button
            variant='flat'
            href={href}
            className={`${menuStyles.item} ${props.className ?? ''}`}
          />
        )
      }
      {...props}
    >
      {Icon ? <Icon size={16} width={16} style={{ color: iconColor }} /> : null}
      {children}
    </AriakitMenu.MenuItem>
  )
}
